import React, { useCallback, useEffect, useMemo } from 'react';
import { Dropdown, DropdownMenu, DropdownItem } from 'semantic-ui-react';
import { useTranslations } from 'src/hooks/translataions';
import { locals } from 'src/constants/locals';
import { useTypeView2d } from 'src/components/TypeView2d/useTypeView2d';
import { useConvertToFormat } from 'src/components/dropdowns/hooks';
import { useSelector } from 'react-redux';
import { getCurrentLang } from 'src/store/app/selectors';
import DOMPurify from 'dompurify';
import { useStyles } from './styles';

export const TypeView2d: React.FC = () => {
  const styles = useStyles({});
  const currentLang = useSelector(getCurrentLang);
  const {
    getTranslations, fetchAppTranslations, getAppTranslationBySystemName, appTranslationsData,
  } = useTranslations();
  const {
    viewList,
    selectedType,
    handleOnChange,
  } = useTypeView2d();
  const { currentData } = useConvertToFormat(viewList, undefined, false);

  useEffect(() => {
    fetchAppTranslations();
  }, []);

  const getAppTranslation = useCallback((appSystemName: string): string => {
    return getAppTranslationBySystemName(appSystemName)?.translates?.[currentLang] || appSystemName;
  }, [appTranslationsData, currentLang]);

  const currentDataWithAppTranslations = useMemo(() => {
    return currentData.map((item) => ({
      ...item,
      text: getAppTranslation(item.key),
    }));
  }, [appTranslationsData, currentData]);

  if (!viewList.length) return null;

  const trigger = (value: string) => {
    return <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(getAppTranslation(value)) }} />;
  };

  return (
    <div>
      {getTranslations(locals.appTranslations.appShow)}
      : &nbsp;
      {currentDataWithAppTranslations.length && (
        <Dropdown
          inline
          trigger={trigger(selectedType)}
          className={styles.styleOfDropdown}
          value={selectedType}
        >
          <DropdownMenu>
            {currentDataWithAppTranslations.map((item) => (
              <DropdownItem
                key={item.key}
                text={null}
                content={trigger(item.text)}
                onClick={() => handleOnChange(item.value)}
              />
            ))}
          </DropdownMenu>
        </Dropdown>
      ) }
    </div>
  );
};
